import { JsonRpcErrorDto } from '../models/json-rpc-error.dto';

export class JsonRpcError<T = any> extends Error {
  public readonly name = 'JsonRpcError';
  public readonly code: number;
  public readonly data: T;

  constructor(public innerError: JsonRpcErrorDto) {
    super(innerError.message || '');

    this.code = innerError.code;
    this.data = innerError.data;
  }
}
